<ion-header>
  <ion-toolbar mode="ios">
    <ion-title modal-title>{{
      options?.headerTitle || "Select Item"
    }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar padding-horizontal mode="ios" *ngIf="!options?.hideSearch">
    <ion-searchbar
      (ionChange)="onSearch()"
      [(ngModel)]="query"
      mode="ios"
      placeholder="Search Item"
    ></ion-searchbar>
    <ion-progress-bar type="indeterminate" *ngIf="searching"></ion-progress-bar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list *ngIf="items?.length > 0; else noItems">
    <ion-grid no-padding>
      <ion-row>
        <ion-col no-padding size="12" *ngFor="let item of items">
          <rcyl-item
            [item]="item"
            [isSelected]="item.id === selectedItemId"
            (select)="itemClicked($event)"
          ></rcyl-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-list>

  <ng-template #noItems>
    <div
      style="height: 60vh; display: flex; width: 100%; flex-direction: column"
      align-items-center
      justify-content-center
    >
      <div text-center *ngIf="items === null">
        <ion-spinner></ion-spinner><br />
        <div font-medium>Loading...</div>
      </div>
      <div padding-horizontal text-center *ngIf="items?.length === 0">
        <ion-text color="primary" text-large font-bold
          >No Items found!</ion-text
        >
      </div>
    </div>
  </ng-template>
</ion-content>
<ion-footer no-box-shadow="" *ngIf="selectedItemId">
  <ion-col size="12">
    <ion-button
      centered
      (click)="submit()"
      class="ion-no-margin"
      recykal-button
      size="large"
      expand="block"
      color="primary"
    >
      {{ options?.submitBtnText || "Proceed" }}
    </ion-button>
  </ion-col>
</ion-footer>
